<template>
    <section class="fichas-epidemiologicas">
        <h4>Fichas Epidemiológicas</h4>

        <!-- Filtros de categorías -->
        <div class="filter-tabs">
            <button v-for="category in categories" :key="category.key" @click="activeFilter = category.key"
                :class="['filter-tab', { active: activeFilter === category.key }]">
                {{ category.label }}
            </button>
        </div>

        <!-- Grid de PDFs -->
        <div v-if="filteredPdfs.length === 0" class="no-results">
            <p>No se encontraron fichas para esta categoría.</p>
        </div>

        <div v-else class="pdf-grid-fichas">
            <PdfCard v-for="(pdf, index) in filteredPdfs" :key="index" :title="pdf.title" :category="pdf.category"
                :pdfUrl="pdf.url" />
        </div>
    </section>
</template>

<script>
import PdfCard from "./PdfCard.vue";

export default {
    name: "FichasEpidemiologicas",
    components: { PdfCard },
    data() {
        return {
            activeFilter: 'todos',
            categories: [
                { key: 'todos', label: 'Todos' },
                { key: 'inmediata', label: 'Inmediata' },
                { key: 'semanal', label: 'Semanal' },
            ],
            allPdfs: [
                // Inmediata
                { title: "Alacranismo", url: "https://drive.google.com/file/d/1K80rb_vbDKK95ZdNY8KC_JZdEd76zM4g/view", category: "inmediata" },
                { title: "Ofidismo (Mordedura de Víbora)", url: "https://drive.google.com/file/d/1qAC7lX4UGDL1FIOqKF_c6Lw1L8ZV87Vh/view", category: "inmediata" },
                { title: "Botulismo", url: "https://drive.google.com/file/d/1ZL_cFvVXrHPsPpmqJssMPGrfqAJIrjlt/view", category: "inmediata" },
                { title: "Brucelosis Aguda", url: "https://drive.google.com/file/d/1ztzTqERDeRq6WyQcuURoeCYINPiRKLkN/view", category: "inmediata" },
                { title: "Coqueluche", url: "https://drive.google.com/file/d/1Xns6xr9GQwqTtC3tY9iO1fT4IquTx1U7/view", category: "inmediata" },
                { title: "COVID / Influenza / OVR Unificada", url: "https://drive.google.com/open?id=1ZTwUaA3tTgT8jE8P-ZI9i1xVcYECArMG&authuser=0", category: "inmediata" },
                { title: "Sarampión y Rubéola", url: "https://drive.google.com/file/d/1eYi9ASlexqarWhTRhrNePkidDFrQw5kZ/view", category: "inmediata" },
                { title: "Difteria", url: "https://drive.google.com/file/d/1eu7bbScE7a_HKgsfGgdPakeFcImIFKNx/view", category: "inmediata" },
                { title: "Encefalitis Equina del Oeste", url: "https://drive.google.com/file/d/1K4YrGhblYHrLEcXKKDC66HmR7tHOx20Y/view", category: "inmediata" },
                { title: "ETA (Enf. Transmitida por Alimentos)", url: "https://drive.google.com/file/d/18nnBxzyi4XEQRWV3mYJY1d8eFEm_75nB/view", category: "inmediata" },
                { title: "Fiebre Tifoidea y Paratifoidea", url: "https://drive.google.com/file/d/1Iz6hrfy2PAfNzfdTZqCA7YMlPwBaCbAN/view", category: "inmediata" },
                { title: "Hantavirus", url: "https://drive.google.com/file/d/19o5UPbTwxcsvmIxMtJvDgvjhuP9sMOb7/view", category: "inmediata" },
                { title: "Hepatitis de Origen Desconocido", url: "https://drive.google.com/file/d/1IaIbf-BtVV1gnoi5jnmJUnpWn-ubcVY6/view", category: "inmediata" },
                { title: "Influenza Aviar", url: "https://drive.google.com/file/d/1G3xRS1ANpzomQZLXzv_HyIgGXQW9hgme/view", category: "inmediata" },
                { title: "Listeriosis", url: "https://drive.google.com/file/d/1bF_FFVmzLfWIcNg-fK8LApwKUEbKBGpq/view", category: "inmediata" },
                { title: "Meningoencefalitis", url: "https://drive.google.com/file/d/1Ab0kuf_3RGxAvjYKdSz9aChvNlDicowa/view", category: "inmediata" },
                { title: "Infecciones Invasivas Inmunoprevenibles", url: "https://drive.google.com/file/d/1M1oGkA04A_LVQxRh02IIBQE-rJg_F1Iw/view", category: "inmediata" },
                { title: "Parálisis Fláccida Aguda (PAF)", url: "https://drive.google.com/file/d/1-LUY4hqSqzdcmRizUntMzZH1SHYnuKve/view", category: "inmediata" },
                { title: "Rubéola Congénita", url: "https://drive.google.com/file/d/1co8ljSK8KA3R6O4V2Ua0cmbfFRgOx4T2/view", category: "inmediata" },
                { title: "Síndrome Febril Agudo Inespecífico", url: "https://drive.google.com/file/d/1goWWW5cj_8S8-St53v89Va06I89NRYe5/view", category: "inmediata" },
                { title: "SUH - Infección por STEC", url: "https://drive.google.com/file/d/1je8ege5vaKATLcQs5e6bkxKXkqzFgSnS/view", category: "inmediata" },
                { title: "Tétanos (Otras Edades)", url: "https://drive.google.com/file/d/1AX1FHX8TQyXl-AKFB88afFbDyuIfXqlL/view", category: "inmediata" },
                { title: "Trichinellosis (Triquinosis)", url: "https://drive.google.com/file/d/1yxM8soop4OwJI8Fav4Z5Sle0QK7jUVT2/view", category: "inmediata" },
                { title: "Viruela Símica", url: "https://drive.google.com/file/d/1_kgP5b-GCVQdDep3IpssWfv0DJPWIqu5/view", category: "inmediata" },
                { title: "Otras Infecciones Invasivas Inmunoprevenibles", url: "https://drive.google.com/file/d/1ZtJFLtqmnWaE16K4G1witwG6NNdbSHlf/view", category: "inmediata" },
                { title: "Araneísmo", url: "https://drive.google.com/file/d/1Moi3EZaWM_ggp0uDgH6RMW-k-qkuEZov/view", category: "inmediata" },
                { title: "Difteria (Versión 2)", url: "https://drive.google.com/file/d/1ZQlQwu3N99ZsMdf9-XZG5lwlGHOPqZnD/view", category: "inmediata" },
                { title: "Ébola", url: "https://drive.google.com/file/d/15JnP4UiBgJsAayz86y72xrOJl_dgljV2/view", category: "inmediata" },
                { title: "Psitacosis", url: "https://drive.google.com/file/d/1eBdDBzxX8RQHuUHzco_9dw1t5WTkrr9n/view", category: "inmediata" },
                { title: "Rabia Humana", url: "/docs/ficha-rabia-humana.pdf", category: "inmediata" },
                { title: "Tétanos Neonatal", url: "https://drive.google.com/file/d/119so4YDFWapmkyxLbm8pUcJngibpzcEF/view", category: "inmediata" },
                { title: "COVID / OVR - UMA", url: "https://drive.google.com/file/d/1MF2P_U43kvo0AZqO1mpFyRzjWzmoz_NR/view", category: "inmediata" },
                { title: "Parotiditis Infecciosa", url: "https://drive.google.com/file/d/1U0lk4VA97hJtcczw7vG6lIOyRlE_-5me/view", category: "inmediata" },
                { title: "Tuberculosis (TB)", url: "https://drive.google.com/file/d/1UcfIl_XhDmv56MBdrQqkMQrcSdECD5P9/view", category: "inmediata" },

                // Semanal
                { title: "Hidatidosis", url: "https://drive.google.com/file/d/1dHosZ2zL0DJiYS3CvZwtHOicRTrlqH7A/view", category: "semanal" },
                { title: "Intentos de Suicidio", url: "https://drive.google.com/file/d/1fYsAFFp6zclT5krfNzYwjwjK_lKhX_IP/view", category: "semanal" },
                { title: "Lesiones por Mordedura de Perro", url: "https://drive.google.com/file/d/1RM3djxDHaJiLMifi6xpTmaUcD8eSwBXV/view", category: "semanal" },
                { title: "Sífilis y Hepatitis (Unificada)", url: "https://drive.google.com/file/d/1bkxzC8JFz6cY-j715XYsJqivFt9331ll/view", category: "semanal" },
                { title: "Chagas Agudo Vectorial", url: "https://drive.google.com/file/d/14g6-EJ7aft-1QN6OufWe7T7SCzPpNKUX/view", category: "semanal" },
                { title: "Accidente Potencialmente Rábico", url: "https://drive.google.com/file/d/17RcslNj7od8L_gqzCkpUqAHwObBPvoTR/view", category: "semanal" },
                { title: "Intoxicación por Metales", url: "https://drive.google.com/file/d/1GFSntZVpgOeWVdvpCSyde_IzQ_I0yTS7/view", category: "semanal" },
                { title: "Intoxicación por Plaguicidas", url: "https://drive.google.com/file/d/1tkzasoVt7U_bBmIWXQ4XgEyx2bmXg70Z/view", category: "semanal" },
                { title: "Sífilis Congénita", url: "https://drive.google.com/file/d/1RoFEL44wtV5ODgyCbGB3dLid23Qoc7PI/view", category: "semanal" },
                { title: "Lepra", url: "https://drive.google.com/file/d/1UxUs8unJTjuAvXpqBJwCnoSuAdjHzy9r/view", category: "semanal" },
                { title: "Tuberculosis", url: "https://drive.google.com/file/d/1UcfIl_XhDmv56MBdrQqkMQrcSdECD5P9/view", category: "semanal" },
                { title: "Intoxicacion por Monoxido de Carbono", url: "https://drive.google.com/file/d/1DEYOYqNHl4NY4fsTngvmZlxOTmSriYkW/view", category: "semanal" },
            ]
        };
    },
    computed: {
        filteredPdfs() {
            if (this.activeFilter === 'todos') return this.allPdfs;
            return this.allPdfs.filter(pdf => pdf.category === this.activeFilter);
        }
    }
};
</script>

<!--
============================================================
IMPLEMENTACIÓN ANTERIOR (Directus API) — comentada
============================================================

<script_old>
import PdfCard from "./PdfCard.vue";

export default {
    name: "FichasEpidemiologicas",
    components: {
        PdfCard,
    },
    data() {
        return {
            activeFilter: 'todos',
            isLoading: true,
            categories: [
                { key: 'todos', label: 'Todos' },
                { key: 'prevenibles-vacunas', label: 'Prevenibles por Vacunas' },
                { key: 'vectores-febril', label: 'Enf. por Vectores - Síndrome Febril' },
                { key: 'hepatitis', label: 'Hepatitis' },
                { key: 'its-vih', label: 'ITS y VIH' },
                { key: 'alimentos-agua', label: 'Transmitidas por Alimentos/Agua' },
                { key: 'respiratorias', label: 'Infecciones Respiratorias' },
                { key: 'intoxicaciones', label: 'Intoxicaciones' },
                { key: 'lesiones-salud-mental', label: 'Lesiones y Salud Mental' },
                { key: 'otros-eventos', label: 'Otros Eventos de Salud Pública' },
                { key: 'zoonoticas-humanas', label: 'Zoonóticas Humanas' },
                { key: 'zoonoticas-animales', label: 'Zoonóticas Animales' }
            ],
            fichasPdfs: []
        };
    },
    async mounted() {
        await this.loadFichasFromAPI();
    },
    computed: {
        filteredPdfs() {
            if (this.activeFilter === 'todos') {
                return this.fichasPdfs;
            }
            return this.fichasPdfs.filter(pdf => pdf.category === this.activeFilter);
        }
    },
    methods: {
        async loadFichasFromAPI() {
            this.isLoading = true;
            try {
                const response = await fetch(`${process.env.VUE_APP_DIRECTUS_URL}/items/portal_salud`);
                const data = await response.json();

                const validCategoryNames = [
                    'prevenibles-vacunas',
                    'vectores-febril',
                    'hepatitis',
                    'its-vih',
                    'alimentos-agua',
                    'respiratorias',
                    'intoxicaciones',
                    'lesiones-salud-mental',
                    'otros-eventos',
                    'zoonoticas-humanas',
                    'zoonoticas-animales'
                ];

                const fichasItems = data.data.filter(item =>
                    validCategoryNames.includes(item.Nombre) &&
                    item.Carga_PDFS &&
                    item.Carga_PDFS.length > 0
                );

                const allPdfs = [];
                for (const ficha of fichasItems) {
                    const pdfs = await this.loadPdfsForCategory(ficha.id, ficha.Nombre);
                    allPdfs.push(...pdfs);
                }

                this.fichasPdfs = allPdfs;
            } catch (error) {
                console.error('Error loading fichas:', error);
                this.fichasPdfs = [];
            } finally {
                this.isLoading = false;
            }
        },

        async loadPdfsForCategory(documentId, categoryKey) {
            try {
                const url = `${process.env.VUE_APP_DIRECTUS_URL}/items/portal_salud_files?filter[portal_salud_id][_eq]=${documentId}&fields=directus_files_id.*`;
                const response = await fetch(url);
                if (!response.ok) return [];
                const data = await response.json();
                return (data.data || [])
                    .map((rel) => rel.directus_files_id)
                    .filter((f) => f)
                    .map((file) => ({
                        title: this.formatFileName(file.filename_download || file.title || 'Archivo PDF'),
                        url: `${process.env.VUE_APP_DIRECTUS_URL}/assets/${file.id}`,
                        category: categoryKey,
                        fileId: file.id,
                        originalName: file.filename_download || file.title
                    }));
            } catch (error) {
                console.error(`Error loading PDFs for category ${categoryKey}:`, error);
                return [];
            }
        },

        formatFileName(filename) {
            if (!filename) return 'Archivo PDF';
            let name = filename.replace(/\.(pdf|PDF)$/, '');
            name = name.replace(/[-_]/g, ' ');
            name = name.replace(/^\d+\s*[-_]?\s*/, '');
            name = name.replace(/\b\w/g, letter => letter.toUpperCase());
            return name.replace(/\s+/g, ' ').trim() || 'Archivo PDF';
        }
    }
};
</script_old>
-->

<style>
.fichas-epidemiologicas {
    width: 100%;
    max-width: 100vw;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    padding: 10px 20px;
    margin: 0 auto;
    overflow-x: hidden;
    box-sizing: border-box;
}

.fichas-epidemiologicas h4 {
    background-color: #ff6b35;
    color: white;
    padding: 15px 30px;
    margin: 10px auto 20px auto;
    border-radius: 8px;
    font-size: 1.3rem;
    font-weight: bold;
    width: auto;
    max-width: 900px;
    text-align: center;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    display: block;
}

.filter-tabs {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0;
    margin: 0 auto 40px auto;
    width: auto;
    max-width: 500px;
    border-radius: 8px;
    box-sizing: border-box;
}

.filter-tab {
    background-color: #f8f9fa;
    border: none;
    padding: 16px 24px;
    cursor: pointer;
    transition: all 0.3s ease;
    font-weight: 600;
    color: #495057;
    flex: 1;
    text-align: center;
    border-right: 1px solid #dee2e6;
    font-size: 15px;
    white-space: nowrap;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
}

.filter-tab:last-child {
    border-right: none;
}

.filter-tab:hover {
    background-color: #e9ecef;
    transform: translateY(-1px);
}

.filter-tab.active {
    background-color: #ff6b35;
    color: white;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(255, 107, 53, 0.3);
}

.pdf-grid-fichas {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    justify-content: center;
    justify-items: center;
    gap: 25px;
    width: 100%;
    max-width: 1200px;
    margin: 10px auto 0 auto;
    padding: 0 20px;
    box-sizing: border-box;
}

.no-results {
    text-align: center;
    padding: 40px 20px;
    color: #666;
    font-size: 1.1rem;
}

@media screen and (max-width: 768px) {
    .fichas-epidemiologicas {
        padding: 10px 15px;
    }

    .fichas-epidemiologicas h4 {
        padding: 12px 20px;
        font-size: 1.1rem;
        margin: 5px auto 15px auto;
        max-width: calc(100vw - 30px);
    }

    .filter-tabs {
        max-width: calc(100vw - 30px);
        margin: 0 auto 30px auto;
    }

    .filter-tab {
        padding: 12px 16px;
        font-size: 13px;
    }

    .pdf-grid-fichas {
        grid-template-columns: 1fr;
        gap: 20px;
        padding: 0 15px;
        max-width: calc(100vw - 30px);
    }
}

@media screen and (max-width: 480px) {
    .filter-tabs {
        flex-wrap: wrap;
        max-width: calc(100vw - 16px);
        gap: 2px;
    }

    .filter-tab {
        flex: 1 1 calc(50% - 1px);
        border-right: none;
        border-bottom: 1px solid #dee2e6;
        padding: 12px 14px;
        font-size: 13px;
    }

    .filter-tab:hover,
    .filter-tab.active {
        transform: none;
    }

    .pdf-grid-fichas {
        grid-template-columns: 1fr;
        gap: 12px;
        padding: 0 8px;
        max-width: calc(100vw - 16px);
    }
}
</style>
